const connectionStatusConstants = {
    STARTED_PRELOADING: 'startedPreloading',
    RECONNECTING: 'reconnecting',
    CONNECTION_RESTORED: 'connectionRestored',
    SAVED: 'saved',
    DISCONNECTED: 'disconnected',
    OFFLINE_MODE: 'offlineMode',
    SERVER_ERROR: 'serverError',
    SYNCHRONISING: 'synchronising',
    SHORT_DURATION: 1500,
    LONG_DURATION: 3000,
};
export default connectionStatusConstants;
